import { render, staticRenderFns } from "./CarouselVirtualSlides.vue?vue&type=template&id=f9098dee&scoped=true"
import script from "./CarouselVirtualSlides.vue?vue&type=script&lang=js"
export * from "./CarouselVirtualSlides.vue?vue&type=script&lang=js"
import style0 from "./CarouselVirtualSlides.vue?vue&type=style&index=0&id=f9098dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9098dee",
  null
  
)

export default component.exports